export const LOAD_SESSION_DATA = 'LOAD_SESSION_DATA';
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const USER_DISPLAY_NAME = 'USER_DISPLAY_NAME';
export const CONFIGURATION = 'CONFIGURATION';
export const SITE_TITLE = 'SITE_TITLE';
export const SITE_SUBTITLE = 'SITE_SUBTITLE';
export const LOAD_THEME = 'LOAD_THEME';
export const SET_THEME = 'SET_THEME';
export const THEME = 'THEME';
export const LOGOUT = 'LOGOUT';
export const RESET_STORE_STATE = 'RESET_STORE_STATE';
export const SET_SEARCH_CRITERIA = 'SET_SEARCH_CRITERIA';
export const SEARCH_CRITERIA = 'SEARCH_CRITERIA';
export const CREATE_CASEID = 'CREATE_CASEID';
export const SET_CASEID = 'SET_CASEID';
export const SEARCH_CASEID = 'SEARCH_CASEID';
export const CASEID = 'CASEID';
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const CATEGORIES = 'CATEGORIES';
export const PERFORM_SEARCH = 'PERFORM_SEARCH';
export const LOAD_SEARCH_PROGRESS = 'LOAD_SEARCH_PROGRESS';
export const CANCEL_SEARCH = 'CANCEL_SEARCH';
export const FIND_SEARCH_BY_CASEID = 'FIND_SEARCH_BY_CASEID';
export const SET_ACTIVE_SEARCH_ID = 'SET_ACTIVE_SEARCH_ID';
export const SET_ACTIVE_WEBSOCKET = 'SET_ACTIVE_WEBSOCKET';
export const ACTIVE_SEARCH_ID = 'ACTIVE_SEARCH_ID';
export const CURRENT_SEARCH = 'CURRENT_SEARCH';
export const UPDATE_CURRENT_SEARCH = 'UPDATE_CURRENT_SEARCH';
export const LOAD_SEARCH_RESULTS = 'LOAD_SEARCH_RESULTS';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const SEARCH_RESULTS_TABLE = 'SEARCH_RESULTS_TABLE';
export const SEARCH_RESULTS_COLUMNS = 'SEARCH_RESULTS_COLUMNS';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const OBSERVE_SEARCH = 'OBSERVE_SEARCH';
export const UPDATE_OBSERVATION = 'UPDATE_OBSERVATION';
export const FAIL_AS_INACTIVE = 'FAIL_AS_INACTIVE';
export const CURRENT_SEARCH_ERROR_STATUS = 'CURRENT_SEARCH_ERROR_STATUS';
export const SET_CURRENT_SEARCH_ERROR_STATUS = 'SET_CURRENT_SEARCH_ERROR_STATUS';
